import { createAction, props } from '@ngrx/store';

export const deleteOrganisation = createAction(
  '[Organisation] Delete Organisation',
  props<{ organisationId: string }>()
);

export const deleteOrganisationSuccess = createAction(
  '[Organisation] Delete Organisation Success',
  props<{ organisationId: string }>()
);

export const deleteOrganisationFailure = createAction(
  '[Organisation] Delete Organisation Failure',
  props<{ organisationId: string; error: any }>()
);
import { Organisation } from './organisation.interface';
import { User } from '../user/user.interface';
import { RoleTypes } from './role.interface';
import { ResourceData } from '../elements/resource/resource.types';

export const OrganisationFeature = 'Organisation';

function getActionName(action: string) {
  return `[${OrganisationFeature}] ${action}`;
}

export const loadOrganisations = createAction(getActionName('list'));

export const loadOrganisationById = createAction(
  getActionName('get by ID'),
  props<{ id: string }>(),
);

export const setIsSuperAdmin = createAction(
  getActionName('setIsSuperAdmin'),
  props<{ value: boolean }>(),
);

export const addUserToOrganisation = createAction(
  getActionName('addUserToOrganisation'),
  props<{ email: string; role: RoleTypes }>(),
);

export const createOrganisation = createAction(
  getActionName('create'),
  props<{ organisation: Partial<Organisation> }>(),
);

export const setOrganisationFromProject = createAction(
  getActionName('set-org-from-project'),
  props<{ organisation: ResourceData }>(),
);

export const setOrganisation = createAction(
  getActionName('set'),
  props<{ organisation: Organisation }>(),
);

export const setOrgIsLoaded = createAction(
  getActionName('set-org-is-loaded'),
  props<{ value: boolean }>(),
);

export const setUserRoleInOrganisation = createAction(
  getActionName('set-new-role-in-org'),
  props<{ organisationId: string; userId: string; role: RoleTypes }>(),
);

export const setOrganisations = createAction(
  getActionName('set batch'),
  props<{ organisations: Organisation[] }>(),
);

export const setCurrentOrganisationID = createAction(
  getActionName('organisation:set-current-org-id'),
  props<{ ID: string }>(),
);

export const assignUsersToOrganisation = createAction(
  getActionName('assign users'),
  props<{ users: User[]; organisation: Organisation }>(),
);

export const saveOrganisationColorPalette = createAction(
  getActionName('save-color-palette'),
  props<{ colorPalette: Record<string, string> }>(),
);

export const setOrganisationColorPalette = createAction(
  getActionName('save-color-palette-base'),
  props<{ colorPalette: Record<string, string> }>(),
);

export const saveOrganisation = createAction(
  getActionName('save-save-organisation'),
  props<{ id: string }>(),
);
